import * as yup from 'yup'

import { BookingRoleNames } from '../../../entity'

export const addUnitManagerPayloadSchema = yup.object({
  userId: yup.string().required(),
  role: yup.mixed<BookingRoleNames>().oneOf(Object.values(BookingRoleNames)),
  canChangeRole: yup.boolean().optional().nullable().default(false),
})
